module.exports = {
	CHALLENGE_NAMES: {
		CONFIRM_SIGN_IN_WITH_TOTP_CODE: 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
		NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED'
	},
	COOKIE_CONSENT: {
		ACCEPTED: 'accepted',
		PENDING: 'pending',
		REJECTED: 'rejected'
	},
	MEDIA_TYPES: {
		AUDIO: 'audio',
		PHOTO: 'photo',
		VIDEO: 'video'
	},
	STORAGE: {
		COOKIE_CONSENT: 'cc',
		TELEMETRY_SESSION_ID: 'tsid'
	},
	VISIBILITY: {
		PRIVATE: 'private',
		TEAM: 'team',
		COLLABORATORS: 'collaborators'
	}
};
